import { useAdminAttentionCounts } from "@/hooks/useAdminAttentionCounts";

/**
 * Maps the shared admin attention counts onto sidebar routes so badges and
 * dashboard widgets always report the same numbers.
 */
export function useAdminSidebarCounts(): Record<string, number> {
  const counts = useAdminAttentionCounts();

  return {
    "/admin/approval-queue": counts.approvals,
    "/admin/bugs": counts.bugReports,
    "/admin/support": counts.supportTickets,
    "/admin/job-applications": counts.jobApplications,
    "/admin/studio-bookings": counts.studioBookings,
    "/admin/failed-syncs": counts.failedSyncs,
    "/admin/withdrawals": counts.withdrawals,
  };
}
